// Copied from `pdt-old/constants.ts` (do not modify old files).

export const EVENT_NAMES = {
  PAGE_RENDERED: 'page-rendered',
} as const;

export const EVENT_TYPES = {
  LIFE_CYCLE: 'life_cycle',
} as const;

export const PAGE_VALUES = {
  LISTING: 'listing',
  REVIEW: 'review',
  THANKYOU: 'thankyou',
} as const;

// PDT Template and Topic Configuration for XDM Page Load Events
export const PDT_CONFIG = {
  TEMPLATE_ID: 164945,
  TOPIC_NAME: 'mmt_bus_b2c_pdt_client_logging',
} as const;
